import serialize from 'form-serialize'
import axios from 'axios'

function preventSubmitOnEnterKey(e) {
  e = e || event;
  var txtArea = /textarea/i.test((e.target || e.srcElement).tagName);
  return txtArea || (e.keyCode || e.which || e.charCode || 0) !== 13;
}

function handleSuccess(form) {
    const successContainer = form.querySelectorAll('.success')[0];
    form.reset();
    successContainer.classList.add('submitted');

    //smooth not supported yet, but it will be in the future. This is good enough for now..
    document.body.scrollIntoView({ block: "start", behavior: "smooth" });
}
function handleErrors(form, errors, errorContainer) {
  let error;
  let error_messages = '';
  for (let i = 0; i < errors.length; i++) {
    error = errors[i];
    error_messages += '<p>' + error + '</p>';
  }
  if (error_messages === '') {
    error_messages = '<p>Unknown error, please try again.</p>'
  }
  errorContainer.classList.remove('no-errors');
  errorContainer.innerHTML = error_messages;
}

function handleFormSubmit(form) {
  const config = {
    headers: { 'X-REQUESTED-WITH': 'xmlhttprequest' }
  };
  form.onkeypress = preventSubmitOnEnterKey;
  form.onsubmit = function() {
    const formData = serialize(form);
    const errorContainer = form.querySelectorAll('.errors')[0];
    const button = form.querySelectorAll('button')[0];
    button.setAttribute('disabled', true);
    axios.post( '/get-in-touch', formData, config ).then(res => {
      button.removeAttribute('disabled');
      errorContainer.classList.add('no-errors');
      if (!res.data.status) {
        handleErrors(form, res.data.errors, errorContainer);
      } else {
        handleSuccess(form);
      }
    })
    return false;
  }
}

export default handleFormSubmit


// WEBPACK FOOTER //
// ./assets/js/forms/contactSubmit.js